import { createBrowserClient } from "@supabase/ssr";
import { Database } from "@/lib/supabase/database.types";
import { useSession } from "../auth-client";

export function createClient(supabaseAccessToken: string) {
  return createBrowserClient<Database>(
    `${process.env.NEXT_PUBLIC_SUPABASE_URL}`,
    `${process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY}`,
    {
      global: {
        headers: {
          Authorization: `Bearer ${supabaseAccessToken}`,
        },
      },
    }
  );
}

export const useSupabase = () => {
  const session = useSession();
  return createClient(session.data?.supabaseAccessToken ?? "");
};
